export class CommonFilter {
  TimestampType: number;
  //TimestampRange: string;
  PageNumber: string;
  PerPage: string;
  //Operator: string;
  SortByOrder: string;
  ResultOrFileType: number;
  ResultTypeName: string;
  respColumnsList: string[];
  MainFilterID: number;
  UserCriteria: string;
  TZHid: string;
  BrowserDate: string;
  CallEventErrorEvent: boolean;
  ConnDropEvent: boolean;
  ShowNodeConnected: boolean;
  ResulTypeLatestID_CRPagination: string;

  constructor() {
    //this.TimestampType = 1;
    ////this.TimestampRange = "";
    //this.PageNumber = "1";
    //this.PerPage = "200";
    //this.Operator = "";
    this.SortByOrder = "";
    //this.MainFilterID = -1;
    this.UserCriteria = "";
    this.TZHid = "";
    this.BrowserDate = 'none';
    this.CallEventErrorEvent = false;
    this.ConnDropEvent = false;
    this.ShowNodeConnected = false;
    this.ResulTypeLatestID_CRPagination = "";
  }
}

export class GeneralFilter {
  ColumnName: string;
  Operator: number;
  Value: string;
  ValueTo: string;
  LoggedInUserName: string;
  RsltType?: string;
  MainFilterName?: string;
  constructor() {
    LoggedInUserName: "";
    RsltType: "";
  }
  //constructor() {
  //  this.ColumnName = "";
  //  this.Operator = "";
  //  this.Value = "";
  //  this.ValueTo = "";
  //}
}

export enum NETTESTTYPES {
  TCPDATA = 1,
  UDPDATA = 2,
  VOIPDATA = 3,
  ROUTEDATA = 4,
  HTTPDATA = 5,
  FTPDATA = 6,
  DNSDATA = 7,
  SMSDATA = 8,
  EMAILDATA = 9
}

export enum MOBILEINFOTYPES {
  GENERALINFO = 1,
  SIMINFO = 2,
  UEINFO = 3
}
